module.exports = __webpack_public_path__ + "static/media/icon_onboarding_settings.bf8fc3e8.png";